/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

/**
 * Base URL helpers and common utilities for Product Server API
 * 
 * This module provides foundational utilities used by all API submodules.
 */

// ============================================================================
// Base URL Helpers
// ============================================================================

/**
 * Get the base URL for product server endpoints (port 3002)
 * In development, use localhost directly. In production, use relative path.
 */
export function getProductServerBaseUrl(): string {
  return import.meta.env?.DEV ? 'http://localhost:3002' : '';
}

/**
 * Build a full API URL for the product server
 * @param path - API path (e.g., '/api/dashboard/activity')
 * @param params - Optional query parameters
 */
export function buildProductApiUrl(path: string, params?: Record<string, string | number | boolean | undefined>): string {
  const baseUrl = getProductServerBaseUrl();
  const url = new URL(path, baseUrl || window.location.origin);
  
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined) {
        url.searchParams.set(key, String(value));
      }
    }
  }
  
  return url.toString();
}

